export const enum CallVideosLayout {
  /** Take as much space as you can */
  Flex = 'flex',
  /** Display with default proportions with height constraints */
  Proportional = 'proportional',
  /**
   * Like Proprtional but with smaller icons and no height
   * constraint. It's meant to be put in a small container, like
   * the sidebar for example.
   */
  Small = 'small',
}
